import React from 'react';
import QuickAccessUnified from '../QuickAccessUnified';

/**
 * Componente que agrupa todos os itens de acesso rápido
 * Agora baseado em configuração - para adicionar novos tipos, basta editar quickAccessConfig.js
 * 
 * Não é mais necessário criar componentes específicos como QuickAccessTickets, QuickAccessSettings, etc.
 * Basta adicionar uma nova entrada no array quickAccessConfigs
 * 
 * Usa QuickAccessUnified que permite reordenar itens entre diferentes tipos.
 */
const QuickAccessItems = () => {
  return <QuickAccessUnified />;
};

export default QuickAccessItems;

